export enum PatientStatusEnum {
  PRECREATED = 'PRECREATED',
  /* DISABLED = 'DISABLED', */
  ACTIVE = 'ACTIVE',
}
